import { render, staticRenderFns } from "./MessageEdits.vue?vue&type=template&id=72c2b3af&scoped=true"
import script from "./MessageEdits.vue?vue&type=script&lang=js"
export * from "./MessageEdits.vue?vue&type=script&lang=js"
import style0 from "./MessageEdits.vue?vue&type=style&index=0&id=72c2b3af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c2b3af",
  null
  
)

export default component.exports